// Bilingual specialist categories (Hindi / English)
export const SPECIALIZATIONS = [
  { en: "Cardiologist", hi: "हृदय रोग विशेषज्ञ" },
  { en: "Eye Specialist", hi: "नेत्र रोग विशेषज्ञ" },
  { en: "ENT (Ear-Nose-Throat)", hi: "कान-नाक-गला विशेषज्ञ" },
  { en: "Pediatrician", hi: "बाल रोग विशेषज्ञ" },
  { en: "Dermatologist", hi: "त्वचा रोग विशेषज्ञ" },
  { en: "Orthopedic", hi: "अस्थि रोग विशेषज्ञ" },
  { en: "Neurologist", hi: "तंत्रिका रोग विशेषज्ञ" },
  { en: "Gynecologist", hi: "स्त्री रोग विशेषज्ञ" },
  { en: "Dentist", hi: "दंत चिकित्सक" },
  { en: "General Physician", hi: "सामान्य चिकित्सक" },
  { en: "Psychiatrist", hi: "मनोचिकित्सक" },
  { en: "Surgeon", hi: "शल्य चिकित्सक" },
];

export const DEPARTMENTS = [
  "Eye", "Nose", "Ear", "Throat", "Pediatrics", "Cardiology",
  "Dermatology", "Orthopedics", "Neurology", "Gynecology", "Dental", "General Medicine"
];
